// extracted by mini-css-extract-plugin
module.exports = {"snowfallContainer":"Snowfall_snowfallContainer___4SRD","fadeOut":"Snowfall_fadeOut__J456K","snowflake":"Snowfall_snowflake__GlfeG","snowfall":"Snowfall_snowfall__wVbJ4"};